const intToBoolean = [
  { value: true, config: "1" },
  { value: false, config: "0" },
];

const question1List = [
  { value: "0", config: "", label: "select_a_question" },
  { value: "1", config: "1", label: "quest1_1" },
  { value: "2", config: "2", label: "quest1_2" },
  { value: "3", config: "3", label: "quest1_3" },
  { value: "4", config: "4", label: "quest1_4" },
  { value: "5", config: "5", label: "quest1_5" },
  { value: "6", config: "6", label: "quest1_6" },
  { value: "7", config: "7", label: "quest1_7" },
  { value: "8", config: "8", label: "quest1_8" },
  { value: "9", config: "9", label: "quest1_9" },
];

const question2List = [
  { value: "0", config: "", label: "select_a_question" },
  { value: "1", config: "1", label: "quest2_1" },
  { value: "2", config: "2", label: "quest2_2" },
  { value: "3", config: "3", label: "quest2_3" },
  { value: "4", config: "4", label: "quest2_4" },
  { value: "5", config: "5", label: "quest2_5" },
  { value: "6", config: "6", label: "quest2_6" },
  { value: "7", config: "7", label: "quest2_7" },
  { value: "8", config: "8", label: "quest2_8" },
];

const dniEncrypt = "dniEncrypt";
const pwdEncrypt = "pwdEncrypt";

export const commonMapping = {
  intToBoolean,
  dniEncrypt,
  pwdEncrypt,
  question1List,
  question2List,
};

export default commonMapping;
